import { defineMessages } from "@/i18n";
import en from "./en";

export const todoFrameMessages = defineMessages("frames-todo", en);
